import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { showModal } from "actions/currentModal";
import { TAG_MANAGEMENT_MODAL } from "constants/globals";

class DisplayTagsModal extends Component {
  componentDidMount() {
    this.props.actions.showModal(TAG_MANAGEMENT_MODAL, {});
  }

  render() {
    return <div>Display tags modal test</div>;
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ showModal }, dispatch)
  };
}

export default connect(
  null,
  mapDispatchToProps
)(DisplayTagsModal);
